export const selectHasInitializedMessages = (state) => state.chat.hasInitializedMessages;
export const selectMessages = (state) => state.chat.messages;
export const selectIsTyping = (state) => state.chat.isTyping;
export const selectIsAssistantResponding = (state) => state.chat.isAssistantResponding;
export const selectIsChatOpen = (state) => state.chat.isChatOpen;
export const selectIsChatExpanded = (state) => state.chat.isChatExpanded
export const selectTaskStatusMessage = (state) => state.chat.taskStatusMessage;
export const selectActiveRequestId = (state) => state.chat.activeRequestId;
export const selectActiveRequestHasContent = (state) => state.chat.activeRequestHasContent;
